import { inject, Pipe, PipeTransform } from '@angular/core';

import { CurrencyFormatService } from 'app/services/currency';

@Pipe({
    name: 'stbyCurrency',
})
export class CurrencyPipe implements PipeTransform {
    private currencyFormatService = inject(CurrencyFormatService);

    transform(value: number, defaultValue = 0): string {
        return this.currencyFormatService.format(value, defaultValue);
    }
}
